import { render, staticRenderFns } from "./Contact_modal.vue?vue&type=template&id=2a49e492&scoped=true&"
import script from "./Contact_modal.vue?vue&type=script&lang=ts&"
export * from "./Contact_modal.vue?vue&type=script&lang=ts&"
import style0 from "./Contact_modal.vue?vue&type=style&index=0&id=2a49e492&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a49e492",
  null
  
)

export default component.exports